import classNames from "@casino/external/classNames";
import getIconSize from "../getSize/getIconSize";
import type SettingsProps from "../types/SettingsProps";
import getIconHorizontalPosition from "./getIconHorizontalPosition";

const IconLeft = ({ fullWidth, iconLeft, size }: SettingsProps) => (
  <span
    aria-hidden="true"
    className={classNames(
      getIconSize(size),
      fullWidth &&
        `absolute block top-1/2 translate-y-[-50%] ${getIconHorizontalPosition({
          iconLeft,
          size,
        })}`,
    )}
  >
    {iconLeft}
  </span>
);

export default IconLeft;
